import React, { FC } from "react";
import { ThemeProvider, themes } from "./styles";
import { GlobalStyle } from "./css";

const Theme: FC = ({ children }) => {
  return (
    <ThemeProvider theme={themes["light"]}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
